import { render, staticRenderFns } from "./error403.vue?vue&type=template&id=58c7374d"
import script from "./error403.vue?vue&type=script&lang=js"
export * from "./error403.vue?vue&type=script&lang=js"
import style0 from "./error403.vue?vue&type=style&index=0&id=58c7374d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports